import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import toast from 'react-simple-toasts';
import axios from 'axios';
import BaseUrl from '../../BaseUrl';
import Swal from 'sweetalert2';
import "react-country-state-city/dist/react-country-state-city.css";

const Settings = () => {


    const navigate = useNavigate()






    const [merchantId, setMerchantId] = useState(null)
    const [merchantName, setMerchantName] = useState(null)
    const [securedKey, setSecuredKey] = useState(null)
    const [storeId, setStoreId] = useState(null)




    const [data, setData] = useState({})


    useEffect(() => {
        try {

            axios.get(`${BaseUrl.baseUrl}/owner/get/1`).then(res => {
                if (res.data.status === 'ok') {
                    setData(res.data.data)
                    setMerchantId(res.data.data?.merchant_id)
                    setMerchantName(res.data.data?.merchant_name)
                    setSecuredKey(res.data.data?.secured_key)
                    setStoreId(res.data.data?.store_id)
                }
                else if (res.data.status === 'fail') {
                    toast('🚩' + res.data.message)
                }

            }).catch(err => {
                toast('🚨' + err.message)
            })


        } catch (err) {
            toast('🚨 Something went wrong!')
        }

    }, [])




    const submit = () => {
        
            try {
                const param = {
                    merchant_id: merchantId,
                    merchant_name: merchantName,
                    secured_key: securedKey,
                    store_id: storeId,
                }


                axios.put(`${BaseUrl.baseUrl}/owner/update/1`, param).then(res => {
                    if (res.data.status === 'ok') {
                        toast('🎉 Updated Successfully!')
                        // navigate(-1)
                    }
                    else if (res.data.status === 'fail') {
                        toast('🚩' + res.data.message)
                    }

                }).catch(err => {
                    toast('🚨' + err.message)
                })


            } catch (err) {
                toast('🚨 Something went wrong!')
            }

        

    }



    return (
        <div id="content" className="app-content ms-0">
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="#">Pages</Link>
                        </li>
                        <li className="breadcrumb-item active">Settings</li>
                    </ul>
                    <h1 className="page-header mb-0">API Key Settings</h1>
                </div>
                {/* <div className="ms-auto">
                    <Link to="/showPlans" className="btn btn-theme fs-13px fw-semibold ">
                        Show Plan
                    </Link>
                </div> */}
            </div>
            <div className="row gx-4">
                <div className="col-xl-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="response-message" />
                            <div >
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className="mb-2 mt-3">
                                            <label htmlFor="">Merchant Name</label>
                                            <br />
                                            <input
                                                type="text"
                                                name="planName"
                                                placeholder="Enter Merchant Name"
                                                className="form-control"
                                                defaultValue={merchantName}
                                                onChange={(e) => { setMerchantName(e.target.value) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="mb-2 mt-3">
                                            <label htmlFor="">Merchant Id</label> <br />
                                            <input
                                                type="text"
                                                name="price"
                                                placeholder="Enter Merchant Id"
                                                className="form-control"
                                                defaultValue={merchantId}
                                                onChange={(e) => { setMerchantId(e.target.value) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="mb-2 mt-3">
                                            <label htmlFor="">Secured Key</label> <br />
                                            <input
                                                type="text"
                                                name="price"
                                                placeholder="Enter Secured Key"
                                                className="form-control"
                                                defaultValue={securedKey}
                                                onChange={(e) => { setSecuredKey(e.target.value) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="mb-2 mt-3">
                                            <label htmlFor="">Store Id</label> <br />
                                            <input
                                                type="text"
                                                name="price"
                                                placeholder="Enter Store Id"
                                                className="form-control"
                                                defaultValue={storeId}
                                                onChange={(e) => { setStoreId(e.target.value) }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-2 mt-2" style={{ float: "inline-end" }}>
                                    <button type="submit" className="btn btn-theme" onClick={submit}>
                                        Update Settings
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Settings